import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';
import { company } from '../config/company';
import s from '../styles/legalStyles';

const Disclaimer = () => {
  const { language } = useLanguage();
  const isNL = language === 'nl';

  return (
    <div style={s.page}>
      <SEO
        title={isNL ? 'Disclaimer' : 'Disclaimer'}
        description={isNL
          ? `Disclaimer van ${company.brand}. Belangrijke informatie over het gebruik van onze website.`
          : `Disclaimer of ${company.brand}. Important information about using our website.`}
      />
      <div style={s.container}>
        <h1 style={s.title}>Disclaimer</h1>
        <p style={s.lastUpdated}>
          {isNL ? 'Laatst bijgewerkt:' : 'Last updated:'} {company.effectiveDate}
        </p>

        {isNL ? (
          <article style={s.article}>
            <h2 style={s.h2}>Algemeen</h2>
            <p>
              De informatie op de website {company.website} wordt door {company.brand} ({company.name}, KvK{' '}
              {company.kvk}) met de grootst mogelijke zorg samengesteld. Aan de getoonde informatie kunnen echter geen
              rechten worden ontleend.
            </p>

            <h2 style={s.h2}>Geen makelaarsdiensten</h2>
            <p>
              {company.brand} is een onafhankelijk informatie- en doorverwijzingsplatform. Wij zijn geen makelaar,
              taxateur of juridisch adviseur. Het werkelijke vastgoedaanbod, de transactie en de afhandeling worden
              verzorgd door onze partner Nelemans of een andere derde partij.
            </p>

            <h2 style={s.h2}>Geen financieel advies</h2>
            <p>
              De informatie op deze website over investeren in Spaans vastgoed, rendement, belastingen en hypotheek is
              uitsluitend bedoeld als algemene voorlichting. Het betreft <strong>geen financieel, fiscaal of juridisch
              advies</strong>. Raadpleeg altijd een gekwalificeerde adviseur voor uw persoonlijke situatie.
            </p>

            <h2 style={s.h2}>Externe links</h2>
            <p>
              De website bevat links naar externe sites. {company.brand} is niet verantwoordelijk voor de inhoud,
              betrouwbaarheid of beschikbaarheid van deze sites.
            </p>

            <h2 style={s.h2}>Wijzigingen</h2>
            <p>
              {company.brand} behoudt zich het recht voor om de inhoud van de website en deze disclaimer op elk moment
              te wijzigen, zonder voorafgaande kennisgeving.
            </p>

            <h2 style={s.h2}>Contact</h2>
            <p>
              Heeft u opmerkingen of vragen? Mail naar{' '}
              <a style={s.link} href={`mailto:${company.email}`}>{company.email}</a>.
            </p>

            <p style={s.footnote}>
              Zie ook ons <Link style={s.link} to="/privacy">privacybeleid</Link>,{' '}
              <Link style={s.link} to="/cookies">cookiebeleid</Link> en{' '}
              <Link style={s.link} to="/voorwaarden">algemene voorwaarden</Link>.
            </p>
          </article>
        ) : (
          <article style={s.article}>
            <h2 style={s.h2}>General</h2>
            <p>
              The information on the website {company.website} is compiled by {company.brand} ({company.name}, CoC{' '}
              {company.kvk}) with the utmost care. However, no rights can be derived from the displayed information.
            </p>

            <h2 style={s.h2}>No real estate agency services</h2>
            <p>
              {company.brand} is an independent information and referral platform. We are not a real estate agent,
              appraiser or legal advisor. Actual property listings, transactions and handling are conducted by our
              partner Nelemans or another third party.
            </p>

            <h2 style={s.h2}>No financial advice</h2>
            <p>
              The information on this website regarding investing in Spanish real estate, returns, taxes and mortgages
              is intended solely as general information. It does <strong>not constitute financial, tax or legal
              advice</strong>. Always consult a qualified advisor for your personal situation.
            </p>

            <h2 style={s.h2}>External links</h2>
            <p>
              The website contains links to external sites. {company.brand} is not responsible for the content,
              reliability or availability of these sites.
            </p>

            <h2 style={s.h2}>Changes</h2>
            <p>
              {company.brand} reserves the right to change the website content and this disclaimer at any time, without
              prior notice.
            </p>

            <h2 style={s.h2}>Contact</h2>
            <p>
              Comments or questions? Email <a style={s.link} href={`mailto:${company.email}`}>{company.email}</a>.
            </p>

            <p style={s.footnote}>
              See also our <Link style={s.link} to="/privacy">privacy policy</Link>,{' '}
              <Link style={s.link} to="/cookies">cookies policy</Link> and{' '}
              <Link style={s.link} to="/voorwaarden">terms & conditions</Link>.
            </p>
          </article>
        )}
      </div>
    </div>
  );
};

export default Disclaimer;
